import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

function SectionCard({ title, children }) {
  return (
    <div className="card" style={{ marginBottom: 24 }}>
      <div className="card-body">
        <p className="section-title">{title}</p>
        {children}
      </div>
    </div>
  );
}

function Field({ label, value, readOnly, type = 'text', hint }) {
  return (
    <div style={{ marginBottom: 20 }}>
      <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: 'var(--text-muted)', marginBottom: 6 }}>{label}</label>
      <input
        type={type}
        defaultValue={value}
        readOnly={readOnly}
        style={{ width: '100%', maxWidth: 400, padding: '9px 14px', borderRadius: 6, border: '1px solid var(--border-color)', background: readOnly ? 'var(--table-stripe)' : 'var(--bg-main)', color: 'var(--text-primary)', fontSize: 14, outline: 'none', cursor: readOnly ? 'not-allowed' : 'text' }}
      />
      {hint && <p style={{ margin: '4px 0 0', fontSize: 12, color: 'var(--text-muted)' }}>{hint}</p>}
    </div>
  );
}

function Toggle({ label, description, checked, onChange }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 0', borderBottom: '1px solid var(--border-color)' }}>
      <div>
        <div style={{ fontWeight: 600, color: 'var(--text-primary)', fontSize: 14 }}>{label}</div>
        <div style={{ color: 'var(--text-muted)', fontSize: 13, marginTop: 2 }}>{description}</div>
      </div>
      <div
        onClick={onChange}
        style={{ width: 44, height: 24, borderRadius: 12, background: checked ? '#4e73df' : 'var(--border-color)', cursor: 'pointer', position: 'relative', transition: 'background 0.2s', flexShrink: 0 }}
      >
        <div style={{ width: 18, height: 18, borderRadius: '50%', background: '#fff', position: 'absolute', top: 3, left: checked ? 23 : 3, transition: 'left 0.2s', boxShadow: '0 1px 4px rgba(0,0,0,0.2)' }} />
      </div>
    </div>
  );
}

export default function Settings() {
  const { user } = useAuth();
  const [notifs, setNotifs] = useState({ email: true, push: false, weekly: true, security: true });
  const [saved, setSaved] = useState(false);

  const handleSave = () => {
    setSaved(true);
    setTimeout(() => setSaved(false), 2500);
  };

  return (
    <div style={{ maxWidth: 720 }}>
      <SectionCard title="Profile">
        <Field label="Full Name" value={user?.name  || ''} readOnly hint="Managed by your Google account" />
        <Field label="Email"     value={user?.email || ''} readOnly hint="Managed by your Google account" />
      </SectionCard>

      <SectionCard title="Notifications">
        <Toggle label="Email notifications"  description="Receive updates and alerts via email"      checked={notifs.email}    onChange={() => setNotifs((n) => ({ ...n, email: !n.email }))} />
        <Toggle label="Push notifications"   description="Browser push notifications"                checked={notifs.push}     onChange={() => setNotifs((n) => ({ ...n, push: !n.push }))} />
        <Toggle label="Weekly digest"        description="Summary email every Monday morning"        checked={notifs.weekly}   onChange={() => setNotifs((n) => ({ ...n, weekly: !n.weekly }))} />
        <Toggle label="Security alerts"      description="Get notified of suspicious account activity" checked={notifs.security} onChange={() => setNotifs((n) => ({ ...n, security: !n.security }))} />
      </SectionCard>

      <SectionCard title="Preferences">
        <div style={{ marginBottom: 20 }}>
          <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: 'var(--text-muted)', marginBottom: 6 }}>Language</label>
          <select defaultValue="en" style={{ padding: '9px 14px', borderRadius: 6, border: '1px solid var(--border-color)', background: 'var(--bg-main)', color: 'var(--text-primary)', fontSize: 14, outline: 'none', minWidth: 200 }}>
            <option value="en">English</option>
            <option value="ko">한국어</option>
            <option value="es">Español</option>
            <option value="fr">Français</option>
          </select>
        </div>
        <div>
          <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: 'var(--text-muted)', marginBottom: 6 }}>Timezone</label>
          <select defaultValue="et" style={{ padding: '9px 14px', borderRadius: 6, border: '1px solid var(--border-color)', background: 'var(--bg-main)', color: 'var(--text-primary)', fontSize: 14, outline: 'none', minWidth: 200 }}>
            <option value="et">Eastern Time (ET)</option>
            <option value="ct">Central Time (CT)</option>
            <option value="pt">Pacific Time (PT)</option>
            <option value="utc">UTC</option>
          </select>
        </div>
      </SectionCard>

      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 32 }}>
        <button onClick={handleSave} style={{ padding: '10px 28px', borderRadius: 6, background: '#4e73df', color: '#fff', border: 'none', fontWeight: 600, fontSize: 14, cursor: 'pointer' }}>
          Save Changes
        </button>
        {saved && <span style={{ color: '#1cc88a', fontWeight: 600, fontSize: 14 }}>✓ Saved successfully</span>}
      </div>

      <SectionCard title="Danger Zone">
        <p style={{ color: 'var(--text-muted)', fontSize: 14, marginBottom: 16 }}>These actions are irreversible. Please proceed with caution.</p>
        <button style={{ padding: '9px 20px', borderRadius: 6, background: 'transparent', color: '#e74a3b', border: '1px solid #e74a3b', fontWeight: 600, fontSize: 13, cursor: 'pointer' }}>
          Clear All Saved Data
        </button>
      </SectionCard>
    </div>
  );
}
